import { InfoUserResponse, VerificationInfoResponse, VerificationsResponse } from "src/api/interfaces/user";
import { CompanyInfoResponse } from "src/api/interfaces/company";
import {
  COMMIT_USER_ROLE,
  FAILED_FETCH_USER_DATA,
  FAILED_FETCH_USER_REGISTERED_COMPANIES,
  FAILED_FETCH_USER_VERIFICATION_DATA,
  FAILED_FETCH_VERIFICATIONS,
  FAILED_LOGOUT_USER,
  FAILED_FETCH_COMPANY_INFO,
  FETCH_USER_DATA,
  FETCH_USER_VERIFICATION_DATA,
  FETCH_VERIFICATIONS,
  FETCH_COMPANY_INFO,
  LOGOUT_USER,
  SUCCESS_FETCH_USER_DATA,
  SUCCESS_FETCH_USER_REGISTERED_COMPANIES,
  SUCCESS_FETCH_USER_VERIFICATION_DATA,
  SUCCESS_FETCH_VERIFICATIONS,
  SUCCESS_FETCH_COMPANY_INFO,
  TOGGLE_ROUTE_CLEAN,
  UPDATE_USER_DATA
} from "src/services/actions/user";
import { Action } from "../store";

export type CommonUserState = {
  errorFetchUser: [];
  errorFetchVerificationInfo: [];
  errorFetchVerifications: [];
  errorLogout: [];
  user: InfoUserResponse;
  verificationInfo: VerificationInfoResponse;
  verifications: VerificationsResponse;
  companyInfo: CompanyInfoResponse;
  loadingUser: boolean;
  loadingVerification: boolean;
  loadingVerifications: boolean;
  loadingCompanyInfo: boolean;
  registeredCompanies: [];
  loadingRegisteredCompanies: boolean;
  errorFetchRegisteredCompanies: [];
  errorFetchCompanyInfo: [];
  isAdmin: boolean;
  isApprover: boolean;
  isChecker: boolean;
  isMaker: boolean;
  isDeveloper: boolean;
  isExecutor: boolean;
  isReviewer: boolean;
  isOwner: boolean;
  isCustomerService: boolean;
  isRouteClean: boolean;
};

const INITIAL_STATE: CommonUserState = {
  errorFetchUser: [],
  errorFetchVerificationInfo: [],
  errorFetchVerifications: [],
  errorLogout: [],
  user: {} as InfoUserResponse,
  verificationInfo: {} as VerificationInfoResponse,
  verifications: {} as VerificationsResponse,
  companyInfo: {} as CompanyInfoResponse,
  loadingUser: false,
  loadingVerification: false,
  loadingVerifications: false,
  loadingCompanyInfo: false,
  registeredCompanies: [],
  loadingRegisteredCompanies: false,
  errorFetchRegisteredCompanies: [],
  errorFetchCompanyInfo: [],
  isAdmin: false,
  isApprover: false,
  isChecker: false,
  isMaker: false,
  isDeveloper: false,
  isExecutor: false,
  isReviewer: false,
  isCustomerService: false,
  isOwner: false,
  isRouteClean: true
};

const userReducer = (state = INITIAL_STATE, action: Action): CommonUserState => {
  if (action.type === FETCH_USER_DATA) {
    return {
      ...state,
      errorFetchUser: [],
      loadingUser: true
    };
  }

  if (action.type === SUCCESS_FETCH_USER_DATA) {
    return {
      ...state,
      user: action.payload,
      loadingUser: false
    };
  }

  if (action.type === FAILED_FETCH_USER_DATA) {
    return {
      ...state,
      loadingUser: false,
      errorFetchUser: action.payload
    };
  }

  if (action.type === FETCH_USER_VERIFICATION_DATA) {
    return {
      ...state,
      loadingVerification: true
    };
  }

  if (action.type === SUCCESS_FETCH_USER_VERIFICATION_DATA) {
    return {
      ...state,
      verificationInfo: action.payload,
      loadingVerification: false
    };
  }

  if (action.type === FAILED_FETCH_USER_VERIFICATION_DATA) {
    return {
      ...state,
      loadingVerification: false,
      errorFetchVerificationInfo: action.payload
    };
  }

  if (action.type === FETCH_VERIFICATIONS) {
    return {
      ...state,
      loadingVerifications: true
    };
  }

  if (action.type === SUCCESS_FETCH_VERIFICATIONS) {
    return {
      ...state,
      verifications: action.payload,
      loadingVerifications: false
    };
  }

  if (action.type === FAILED_FETCH_VERIFICATIONS) {
    return {
      ...state,
      loadingVerifications: false,
      errorFetchVerifications: action.payload
    };
  }

  if (action.type === SUCCESS_FETCH_USER_REGISTERED_COMPANIES) {
    return {
      ...state,
      registeredCompanies: action.payload,
      loadingRegisteredCompanies: false
    };
  }

  if (action.type === FAILED_FETCH_USER_REGISTERED_COMPANIES) {
    return {
      ...state,
      loadingRegisteredCompanies: false,
      errorFetchRegisteredCompanies: action.payload
    };
  }

  if (action.type === COMMIT_USER_ROLE) {
    return {
      ...state,
      loadingUser: false,
      ...action.payload
    };
  }

  if (action.type === UPDATE_USER_DATA) {
    return {
      ...state,
      user: action.payload
    };
  }

  if (action.type === TOGGLE_ROUTE_CLEAN) {
    return {
      ...state,
      isRouteClean: action.payload
    };
  }

  if (action.type === LOGOUT_USER) {
    return {
      ...INITIAL_STATE
    };
  }
  if (action.type === FAILED_LOGOUT_USER) {
    return {
      ...INITIAL_STATE,
      errorLogout: action.payload
    };
  }

  if (action.type === FETCH_COMPANY_INFO) {
    return {
      ...state,
      loadingCompanyInfo: true
    };
  }

  if (action.type === SUCCESS_FETCH_COMPANY_INFO) {
    return {
      ...state,
      companyInfo: action.payload,
      loadingCompanyInfo: false
    };
  }

  if (action.type === FAILED_FETCH_COMPANY_INFO) {
    return {
      ...state,
      loadingCompanyInfo: false,
      errorFetchCompanyInfo: action.payload
    };
  }

  return state;
};

export default userReducer;
